//=require main.js
//=require components/select2.min.js
$(document).ready(function () {
    $('.slider-banner').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        arrows: false,
        dots: true,
    });

    localStorage.setItem('view', 'grid');
    $('.list-view').click(function () {
        $('.list-partner-list-view').css({'display': 'flex'});
        $('.list-partner').hide();
        localStorage.setItem('view', 'list');
        $(this).attr('src', '/images/v2/doi-tac-trien-khai/icon-list.svg');
        $('.grid-view').attr('src', '/images/v2/doi-tac-trien-khai/icon-grid-active.svg');
    })
    $('.grid-view').click(function () {
        $('.list-partner-list-view').hide();
        $('.list-partner').show();
        localStorage.setItem('view', 'grid');
        $(this).attr('src', '/images/v2/doi-tac-trien-khai/icon-grid.svg');
        $('.list-view').attr('src', '/images/v2/doi-tac-trien-khai/icon-list-active.svg');
    })

    $(document).delegate('.location', 'click', function () {
        $(this).find('.location-show-more').toggle();
    })

    $(document).delegate('.location', 'mouseout', function () {
        $(this).find('.location-show-more').hide();
    })

    $(window).on('load', function () {
        localStorage.removeItem("total");
        localStorage.removeItem("contractorCategory");
        localStorage.removeItem("supplierCategory");
        localStorage.removeItem("partnerCategory");
        localStorage.removeItem("_totalCurrentResult");
    })

    $(window).scroll(function () {
        if ($(window).scrollTop() === ($(document).height() - window.innerHeight)) {
            appendContent();
        }
    });

    function getTypeFromUrl() {
        let type;
        const searchParams = new URLSearchParams(window.location.search)
        if (searchParams.has('type')) {
            type = searchParams.get('type');
        }

        return type;
    }

    $(document).delegate('.category-select', 'change', function () {
        const type = getTypeFromUrl();

        let partnerCategory = [];
        if (type) {
            let partnerName = $('.input-search-partner-by-name').val();
            let province = $(".province option:selected").val();
            partnerCategory = $(this).val();

            localStorage.setItem('partnerCategory', JSON.stringify(partnerCategory));

            const itemList = $('.category-select-block .select2-selection__rendered');

            if (partnerCategory.length > 1) {
                itemList.children().each(function (index, item) {
                    if (index > 1) {
                        $(item).remove();
                    }
                });

                $('.counter').remove();
                if (partnerCategory.length > 1) {
                    let count;
                    if (partnerCategory.length - 2 === 0) {
                        count = '';
                    } else {
                        count = `+${partnerCategory.length - 2}`;
                    }

                    itemList.append(`
                        <li style="position: absolute; right: -23px; top: -8px;font-size: 13px;" class="counter">${count}</li>
                    `)
                }
            }

            $.ajax({
                url: '/filter-doi-tac',
                method: "GET",
                data: {
                    type: type,
                    province: province,
                    partnerCategory: partnerCategory,
                    partnerName: partnerName
                },
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    $('.loading-block').html('<img src="/images/icons/spin.gif" data-id=' + JSON.stringify(data.partnerId) + ' id="loading" data-count="' + data.partnerCount + '" style="cursor: pointer">');
                    let list = eachActionList(data);
                    $('.list-partner-list-view').html(list);
                    let grid = eachActionGrid(data);
                    $('.list-partner').html(grid);
                    $('.overlay').fadeOut();
                }
            });
        }
    })

    $('.province').on('change', function () {
        let partnerName = $('.input-search-partner-by-name').val();
        const type = getTypeFromUrl();
        let province = $(".province option:selected").val();
        let partnerCategory = JSON.parse(localStorage.getItem('partnerCategory'));
        $.ajax({
            url: '/filter-doi-tac',
            method: "GET",
            data: {
                province: province,
                type: type,
                partnerName: partnerName,
                partnerCategory: partnerCategory,
            },
            beforeSend: function () {
                $('.overlay').fadeIn();
            },
            success: function (data) {
                $('.loading-block').html('<img src="/images/icons/spin.gif" data-id=' + JSON.stringify(data.partnerId) + ' id="loading" data-count="' + data.partnerCount + '" style="cursor: pointer">');
                let list = eachActionList(data);
                $('.list-partner-list-view').html(list);
                let grid = eachActionGrid(data);
                $('.list-partner').html(grid);
                $('.overlay').fadeOut();
            }
        });
    })

    $(document).on('keypress',function(event) {
        if (event.key === "Enter") {
            let partnerName = $('.input-search-partner-by-name').val();
            const type = getTypeFromUrl();
            let province = $(".province option:selected").val();
            let partnerCategory = JSON.parse(localStorage.getItem('partnerCategory'));
            $.ajax({
                url: '/filter-doi-tac',
                method: "GET",
                data: {
                    type: type,
                    province: province,
                    partnerName: partnerName,
                    partnerCategory: partnerCategory,
                },
                beforeSend: function () {
                    $('.overlay').fadeIn();
                },
                success: function (data) {
                    console.log('data', data)
                    $('.loading-block').html('<img src="/images/icons/spin.gif" data-id=' + JSON.stringify(data.partnerId) + ' id="loading" data-count="' + data.partnerCount + '" style="cursor: pointer">');
                    let list = eachActionList(data);
                    $('.list-partner-list-view').html(list);
                    let grid = eachActionGrid(data);
                    $('.list-partner').html(grid);
                    $('.overlay').fadeOut();
                }
            });
        }
    })

    $('.search-partner-by-name').click(function () {
        let partnerName = $('.input-search-partner-by-name').val();
        const type = getTypeFromUrl();
        let province = $(".province option:selected").val();
        let partnerCategory = JSON.parse(localStorage.getItem('partnerCategory'));
        $.ajax({
            url: '/filter-doi-tac',
            method: "GET",
            data: {
                type: type,
                province: province,
                partnerName: partnerName,
                partnerCategory: partnerCategory,
            },
            beforeSend: function () {
                $('.overlay').fadeIn();
            },
            success: function (data) {
                console.log('data', data)
                $('.loading-block').html('<img src="/images/icons/spin.gif" data-id=' + JSON.stringify(data.partnerId) + ' id="loading" data-count="' + data.partnerCount + '" style="cursor: pointer">');
                let list = eachActionList(data);
                $('.list-partner-list-view').html(list);
                let grid = eachActionGrid(data);
                $('.list-partner').html(grid);
                $('.overlay').fadeOut();
            }
        });
    })

    $('.filter-block').select2();

    // $('.type').select2({
    //     placeholder: "Phân loại đối tác",
    //     allowClear: true,
    // });
    $('.province').select2({
        placeholder: "Phạm vi hoạt động",
        allowClear: true,
    });

    $('.category-select').select2({
        placeholder: "Danh mục",
        // closeOnSelect : false,
        allowClear: true,
        dropdownCssClass: "category-select-container",
        // tags: true,
    });
})

var eachActionList = function (data) {
    var list = '';
    if (data.partners !== undefined && data.partners.length > 0) {
        $.each(data.partners, function (index, value) {
            let url = "";
            let htmlProvinces = "Không có dữ liệu";
            let htmlLoadMoreProvinces = '';
            if (value.role.type === 'contractor') {
                url += `/nha-thau/${value?.contractor_profile?.slug ? value.contractor_profile.slug : ""}`;
                let provinces = value?.contractor_profile?.provinces;
                if (Array.isArray(provinces) && provinces.length > 0) {
                    htmlLoadMoreProvinces += '<ul class="location-show-more">';
                    provinces.forEach((i, v) => {
                        htmlLoadMoreProvinces += `<li>${i.name}</li>`
                    })
                    if (provinces.length > 1) {
                        htmlProvinces = `${provinces[0].name} + ${provinces.length - 1}`;
                    } else if (provinces.length === 1) {
                        htmlProvinces = `${provinces[0].name}`;
                    } else {
                        htmlProvinces = 'Không có dữ liệu';
                    }
                }
            } else if (value.role.type === 'supplier') {
                url += `/nha-cung-cap/${value?.supplier_profile?.slug ? value.supplier_profile.slug : ""}`;
                let provinces = value?.supplier_profile?.provinces;
                if (Array.isArray(provinces) && provinces.length > 0) {
                    htmlLoadMoreProvinces += '<ul class="location-show-more">';
                    provinces.forEach((i, v) => {
                        htmlLoadMoreProvinces += `<li>${i.name}</li>`
                    })
                    if (provinces.length > 1) {
                        htmlProvinces = `${provinces[0].name} + ${provinces.length - 1}`;
                    } else if (provinces.length === 1) {
                        htmlProvinces = `${provinces[0].name}`;
                    } else {
                        htmlProvinces = 'Không có dữ liệu';
                    }
                }
            }
            htmlLoadMoreProvinces += '</ul>'
            list += `<div class="col-12 mb-4 item-partner-list">
                        <div class="item">
                            <div class="thumbnail">
                            <a href="${url}" class="text-decoration-none">
                                <img src="${value?.supplier_profile?.cover_image
                ? value.supplier_profile.cover_image.url
                : value?.contractor_profile?.cover_image
                    ? value.contractor_profile.cover_image.url
                    : '/images/NCC-ĐVTC-cover.jpg'}" class="w-100">
                                </a>
                            </div>
                            <div class="information">
                                <div class="header d-flex">
                                    <div class="avatar">
                                        <img src="${value?.supplier_profile?.avatar
                ? value.supplier_profile.avatar.url
                : value?.contractor_profile?.avatar
                    ? value.contractor_profile.avatar.url
                    : '/images/avatar-nhacungcap-nhathau.png'}">
                                    </div>
                                    <div class="content">
                                        <div class="name text-decoration-none">
                                        <a href="${url}">
                                            ${value?.supplier_profile?.name
                ? value.supplier_profile.name
                : value?.contractor_profile?.name
                    ? value.contractor_profile.name
                    : 'Không xác định'}
                                            </a>
                                        </div>
                                        <div class="d-flex mt-2 mb-2" style="color: #6A6A6A">
                                            <div class="mr-4 icon">
                                                ${value.supplier_profile !== undefined ? '<img src="/images/icons/icon-nha-cung-cap.svg" style="width: 15px"> Đơn vị nhà cung cấp' : '<img src="/images/icons/icon-nha-thau.svg" style="width: 15px"> Đơn vị nhà thầu'}
                                            </div>
                                            <div class="mr-4 icon location">
                                                <img src="/images/v2/doi-tac-trien-khai/icon-location.svg" style="width: 15px">
                                                ${htmlProvinces}
                                                ${htmlLoadMoreProvinces}
                                            </div>
                                            <div class="icon">
                                                ${value.role.type === 'contractor' && value?.contractor_profile?.count_portfolio
                ? '<img src="/images/icons/project_black.svg">&nbsp;' + value.contractor_profile.count_portfolio + ' công trình'
                : value.role.type === 'supplier'
                    ? ''
                    : '<img src="/images/icons/project_black.svg">&nbsp; 0 công trình'}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="footer line-camp-8">
                                    ${value?.supplier_profile?.seo_description
                ? value.supplier_profile.seo_description
                : value?.contractor_profile?.seo_description
                    ? value.contractor_profile.seo_description
                    : 'Không xác định'}
                                </div>
                            </div>
                        </div>
                    </div>`
        })
    } else {
        list += `<div class="col-12 text-center">Không tìm thấy kết quả nào</div>`
    }
    return list;
}

var eachActionGrid = function (data) {
    let html = '';
    if (data.partners !== undefined && data.partners.length > 0) {
        $.each(data.partners, function (index, value) {
            let url = "";
            let htmlProvinces = "Không có dữ liệu";
            let htmlLoadMoreProvinces = '';
            if (value.role.type === 'contractor') {
                url += `/nha-thau/${value?.contractor_profile?.slug ? value.contractor_profile.slug : ""}`;
                let provinces = value?.contractor_profile?.provinces;
                if (Array.isArray(provinces) && provinces.length > 0) {
                    htmlLoadMoreProvinces += '<ul class="location-show-more">';
                    provinces.forEach((i, v) => {
                        htmlLoadMoreProvinces += `<li>${i.name}</li>`
                    })
                    if (provinces.length > 1) {
                        htmlProvinces = `${provinces[0].name} + ${provinces.length - 1}`;
                    } else if (provinces.length === 1) {
                        htmlProvinces = `${provinces[0].name}`;
                    } else {
                        htmlProvinces = 'Không có dữ liệu';
                    }
                }
            } else if (value.role.type === 'supplier') {
                url += `/nha-cung-cap/${value?.supplier_profile?.slug ? value.supplier_profile.slug : ""}`;
                let provinces = value?.supplier_profile?.provinces;
                if (Array.isArray(provinces) && provinces.length > 0) {
                    htmlLoadMoreProvinces += '<ul class="location-show-more">';
                    provinces.forEach((i, v) => {
                        htmlLoadMoreProvinces += `<li>${i.name}</li>`
                    })
                    if (provinces.length > 1) {
                        htmlProvinces = `${provinces[0].name} + ${provinces.length - 1}`;
                    } else if (provinces.length === 1) {
                        htmlProvinces = `${provinces[0].name}`;
                    } else {
                        htmlProvinces = 'Không có dữ liệu';
                    }
                }
            }
            htmlLoadMoreProvinces += '</ul>'
            html += `<div class="col-xl-3 col-md-6 col-12 item-partner">
                        <div class="block-thumbnail position-relative">
                            <a href="${url}">
                                <img src="${value?.supplier_profile?.cover_image
                ? value.supplier_profile.cover_image.url
                : value?.contractor_profile?.cover_image
                    ? value.contractor_profile.cover_image.url
                    : '/images/NCC-ĐVTC-cover.jpg'}" class="w-100">
                                <div class="img-overlay"></div>
                            </a>
                        </div>
                        <div class="block-information">
                            <div class="other d-flex">
                                <div class="other-left">
                                    <img src="${value?.supplier_profile?.avatar
                ? value.supplier_profile.avatar.url
                : value?.contractor_profile?.avatar
                    ? value.contractor_profile.avatar.url
                    : '/images/avatar-nhacungcap-nhathau.png'}">
                                </div>
                                <div class="other-right">
                                    <div class="name line-camp-2">
                                        <a href="${url}">
                                            ${value?.supplier_profile?.name
                ? value.supplier_profile.name
                : value?.contractor_profile?.name
                    ? value.contractor_profile.name
                    : 'Không xác định'}
                                        </a>
                                    </div>
                                    <div class="mt-1 mb-1">
                                        ${value.supplier_profile !== undefined ? '<img src="/images/icons/icon-nha-cung-cap-white.svg" style="width: 15px"> Đơn vị nhà cung cấp'
                : '<img src="/images/icons/icon-nha-thau-white.svg" style="width: 15px"> Đơn vị nhà thầu'}
                                    </div>
                                    <div class="d-flex">
                                        <div class="block-star">
                                            <ul>
                                                <li><img src="/images/icons/icon-star.svg"></li>
                                                <li><img src="/images/icons/icon-star.svg"></li>
                                                <li><img src="/images/icons/icon-star.svg"></li>
                                                <li><img src="/images/icons/icon-star.svg"></li>
                                                <li><img src="/images/icons/icon-star.svg"></li>
                                            </ul>
                                        </div>

                                    </div>
                                    <div class="d-flex" style="margin-top: -10px">
                                        <div class="location">
                                            <img src="/images/icons/icon-location.svg">&nbsp;
                                             ${htmlProvinces}
                                             ${htmlLoadMoreProvinces}
                                        </div>
                                        <div class="ml-2">
                                            ${value.role.type === 'contractor' && value?.contractor_profile?.count_portfolio
                ? '<img src="/images/v2/doi-tac-trien-khai/icon-project.svg">&nbsp;' + value.contractor_profile.count_portfolio + ' công trình'
                : value.role.type === 'supplier'
                    ? ''
                    : '<img src="/images/v2/doi-tac-trien-khai/icon-project.svg">&nbsp; 0 công trình'}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>`
        })
    } else {
        html += `<div class="col-12 text-center">Không tìm thấy kết quả nào</div>`
    }
    return html;
}

var appendContent = function () {
    let _totalCurrentResult;
    let partnerName = $('.input-search-partner-by-name').val();
    let type;
    const searchParams = new URLSearchParams(window.location.search)
    if (searchParams.has('type')) {
        type = searchParams.get('type');
    }
    let province = $(".province option:selected").val();
    let ids = $('#loading').data('id');
    let total = $('#loading').data('count');
    let styleView = localStorage.getItem('view');
    $.ajax({
        url: '/load-more-doi-tac',
        type: 'get',
        data: {
            _start: _totalCurrentResult,
            province: province !== undefined ? province : '',
            type: type !== undefined ? type : '',
            ids: ids,
            partnerName: partnerName !== undefined ? partnerName : '',
        },
        dataType: 'json',
        beforeSend: function () {
            if (styleView === 'list') {
                _totalCurrentResult = $(".item-partner-list").length;
            } else {
                _totalCurrentResult = $(".item-partner").length;
            }
            if (_totalCurrentResult < total) {
                $('#loading').fadeIn();
            }
        },
        success: function (data) {
            const __totalCurrentResult = localStorage.getItem('_totalCurrentResult');
            if (__totalCurrentResult) {
                if (styleView === 'list') {
                    _totalCurrentResult = $(".item-partner-list").length;
                } else {
                    _totalCurrentResult = $(".item-partner").length;
                }
            } else {
                _totalCurrentResult = __totalCurrentResult;
            }
            localStorage.setItem('_totalCurrentResult', _totalCurrentResult);
            if (_totalCurrentResult < total) {
                $('.loading-block').html('<img src="/images/icons/spin.gif" data-id=' + JSON.stringify(data.arrayPartner) + ' data-count=' + data.partnerCount + ' id="loading" style="cursor: pointer">');
                let list = eachActionList(data);
                $('.list-partner-list-view').append(list);
                let grid = eachActionGrid(data);
                $('.list-partner').append(grid);
                $('#loading').fadeOut();
            }
        }
    })
};
